<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-02-04',
        major: [],
        excepts: [],
        items: [

          // [NOTE] Vol.1
          // ================================================================================

          item({
            collection  : 'Gummy1',
            id          : 'C-001',
            rare        : 'SR',
            name        : 'わんわんポリスブルートップス',
            imgUrl      : '/images/items/C-001.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-002',
            rare        : 'SR',
            name        : 'わんわんポリスブルースカート',
            imgUrl      : '/images/items/C-002.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-003',
            rare        : 'SR',
            name        : 'わんわんポリスブルーブーツ',
            imgUrl      : '/images/items/C-003.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-004',
            rare        : 'SR',
            name        : 'わんわんポリスブルーヘアアクセ',
            imgUrl      : '/images/items/C-004.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy1',
            id          : 'C-006',
            rare        : 'SR',
            name        : '[キラMAX] わんわんポリスピンクトップス',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-006',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-005',
            rare        : 'SR',
            name        : 'わんわんポリスピンクスカート',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-005',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-036',
            rare        : 'SR',
            name        : '[再録] わんわんポリスピンクトップス',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-036',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy1',
            id          : 'C-007',
            rare        : 'R',
            name        : 'ダンシングマーチグリーントップス',
            imgUrl      : '/images/items/C-007.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-008',
            rare        : 'R',
            name        : 'ダンシングマーチグリーンスカート',
            imgUrl      : '/images/items/C-008.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-009',
            rare        : 'R',
            name        : 'ダンシングマーチグリーンシューズ',
            imgUrl      : '/images/items/C-009.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-010',
            rare        : 'R',
            name        : 'ダンシングマーチヘアアクセ',
            imgUrl      : '/images/items/C-010.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy1',
            id          : 'C-011',
            rare        : 'R',
            name        : 'クリームピーチソーダトップス',
            imgUrl      : '/images/items/C-011.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-012',
            rare        : 'R',
            name        : 'クリームピーチソーダスカート',
            imgUrl      : '/images/items/C-012.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-013',
            rare        : 'R',
            name        : 'クリームピーチソーダシューズ',
            imgUrl      : '/images/items/C-013.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy1',
            id          : 'C-014',
            rare        : 'R',
            name        : 'クリームソーダヘアアクセ',
            imgUrl      : '/images/items/C-014.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.2
          // ================================================================================

          item({
            collection  : 'Gummy2',
            id          : 'C-022',
            rare        : 'SR',
            name        : 'にゃんにゃんにゃ～すピンクトップス',
            imgUrl      : '/images/items/C-022.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-023',
            rare        : 'SR',
            name        : 'にゃんにゃんにゃ～すピンクスカート',
            imgUrl      : '/images/items/C-023.png',
            kind        : 'スカート',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-024',
            rare        : 'SR',
            name        : 'にゃんにゃんにゃ～すピンクブーツ',
            imgUrl      : '/images/items/C-024.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-025',
            rare        : 'SR',
            name        : 'にゃんにゃんにゃ～すピンクヘアアクセ',
            imgUrl      : '/images/items/C-025.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy2',
            id          : 'C-027',
            rare        : 'SR',
            name        : '[キラMAX] にゃんにゃんにゃ～すブルートップス',
            imgUrl      : '//via.placeholder.com/100/fff/66ccff/?text=C-027',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-026',
            rare        : 'SR',
            name        : 'にゃんにゃんにゃ～すブルースカート',
            imgUrl      : '//via.placeholder.com/100/fff/66ccff/?text=C-026',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-057',
            rare        : 'SR',
            name        : '[再録] にゃんにゃんにゃ～すブルートップス',
            imgUrl      : '//via.placeholder.com/100/fff/66ccff/?text=C-057',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy2',
            id          : 'C-028',
            rare        : 'R',
            name        : 'セーラーチアイエローリボントップス',
            imgUrl      : '/images/items/C-028.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-029',
            rare        : 'R',
            name        : 'セーラーチアイエローリボンスカート',
            imgUrl      : '/images/items/C-029.png',
            kind        : 'スカート',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-030',
            rare        : 'R',
            name        : 'セーラーチアイエローリボンシューズ',
            imgUrl      : '/images/items/C-030.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-031',
            rare        : 'R',
            name        : 'セーラーチアイエローリボンヘアアクセ',
            imgUrl      : '/images/items/C-031.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy2',
            id          : 'C-032',
            rare        : 'R',
            name        : 'ポップコーンショップブルートップス',
            imgUrl      : '/images/items/C-032.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-033',
            rare        : 'R',
            name        : 'ポップコーンショップブルーパンツ',
            imgUrl      : '/images/items/C-033.png',
            kind        : 'スカート',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-034',
            rare        : 'R',
            name        : 'ポップコーンショップブルーシューズ',
            imgUrl      : '/images/items/C-034.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy2',
            id          : 'C-035',
            rare        : 'R',
            name        : 'ポップコーンショップブルーヘアアクセ',
            imgUrl      : '/images/items/C-035.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.3
          // ================================================================================

          item({
            collection  : 'Gummy3',
            id          : 'C-043',
            rare        : 'SR',
            name        : 'がおがおふぁいが～レッドトップス',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-043',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-044',
            rare        : 'SR',
            name        : 'がおがおふぁいが～レッドパンツ',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-044',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-045',
            rare        : 'SR',
            name        : 'がおがおふぁいが～レッドシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-045',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-046',
            rare        : 'SR',
            name        : 'がおがおふぁいが～ヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/333333/?text=C-046',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy3',
            id          : 'C-048',
            rare        : 'SR',
            name        : '[キラMAX] がおがおふぁいが～ブラックトップス',
            imgUrl      : '//via.placeholder.com/100/fff/333333/?text=C-048',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-047',
            rare        : 'SR',
            name        : 'がおがおふぁいが～ブラックパンツ',
            imgUrl      : '//via.placeholder.com/100/fff/333333/?text=C-047',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-072',
            rare        : 'SR',
            name        : '[再録] がおがおふぁいが～ブラックトップス',
            imgUrl      : '//via.placeholder.com/100/fff/333333/?text=C-072',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy3',
            id          : 'C-049',
            rare        : 'R',
            name        : 'セーラーマリンレッドトップス',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-049',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-050',
            rare        : 'R',
            name        : 'セーラーマリンレッドスカート',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-050',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-051',
            rare        : 'R',
            name        : 'セーラーマリンレッドシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-051',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-052',
            rare        : 'R',
            name        : 'セーラーマリンレッドヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-052',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy3',
            id          : 'C-053',
            rare        : 'R',
            name        : 'チェッカーガールグリーントップス',
            imgUrl      : '//via.placeholder.com/100/fff/008f00/?text=C-053',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-054',
            rare        : 'R',
            name        : 'チェッカーガールグリーンスカート',
            imgUrl      : '//via.placeholder.com/100/fff/008f00/?text=C-054',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-055',
            rare        : 'R',
            name        : 'チェッカーガールグリーンシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/008f00/?text=C-055',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy3',
            id          : 'C-056',
            rare        : 'R',
            name        : 'チェッカーガールグリーンヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/008f00/?text=C-056',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.4
          // ================================================================================

          item({
            collection  : 'Gummy4',
            id          : 'C-058',
            rare        : 'SR',
            name        : 'うさもふパティシエールブルートップス',
            imgUrl      : '//via.placeholder.com/100/fff/66ccff/?text=C-058',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-059',
            rare        : 'SR',
            name        : 'うさもふパティシエールブルースカート',
            imgUrl      : '//via.placeholder.com/100/fff/66ccff/?text=C-059',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-060',
            rare        : 'SR',
            name        : 'うさもふパティシエールブルーシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/66ccff/?text=C-060',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-061',
            rare        : 'SR',
            name        : 'うさもふパティシエールブルーヘアアクセ ',
            imgUrl      : '//via.placeholder.com/100/fff/66ccff/?text=C-061',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy4',
            id          : 'C-063',
            rare        : 'SR',
            name        : '[キラMAX] うさもふパティシエールイエロートップス',
            imgUrl      : '//via.placeholder.com/100/fff/ffd479/?text=C-063',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-062',
            rare        : 'SR',
            name        : 'うさもふパティシエールイエロースカート',
            imgUrl      : '//via.placeholder.com/100/fff/ffd479/?text=C-062',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-087',
            rare        : 'SR',
            name        : '[再録] うさもふパティシエールイエロートップス',
            imgUrl      : '//via.placeholder.com/100/fff/ffd479/?text=C-087',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy4',
            id          : 'C-064',
            rare        : 'R',
            name        : 'ハート＆レースグリーントップス',
            imgUrl      : '//via.placeholder.com/100/fff/008f00/?text=C-064',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-065',
            rare        : 'R',
            name        : 'ハート＆レースグリーンスカート',
            imgUrl      : '//via.placeholder.com/100/fff/008f00/?text=C-065',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-066',
            rare        : 'R',
            name        : 'ハート＆レースグリーンシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/008f00/?text=C-066',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-067',
            rare        : 'R',
            name        : 'ハート＆レースグリーンヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-067',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy4',
            id          : 'C-068',
            rare        : 'R',
            name        : 'たんていボーイレッドトップス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=C-068',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-069',
            rare        : 'R',
            name        : 'たんていボーイレッドパンツ',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-069',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-070',
            rare        : 'R',
            name        : 'たんていボーイレッドシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/945200/?text=C-070',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy4',
            id          : 'C-071',
            rare        : 'R',
            name        : 'たんていボーイレッドヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/ff0000/?text=C-071',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.5
          // ================================================================================

          item({
            collection  : 'Gummy5',
            id          : 'C-073',
            rare        : 'SR',
            name        : 'くまみみクルーブルートップス',
            imgUrl      : '//via.placeholder.com/100/fff/00f/?text=C-073',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-074',
            rare        : 'SR',
            name        : 'くまみみクルーブルースカート',
            imgUrl      : '//via.placeholder.com/100/fff/00f/?text=C-074',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-075',
            rare        : 'SR',
            name        : 'くまみみクルーシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/00f/?text=C-075',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-076',
            rare        : 'SR',
            name        : 'くまみみクルーヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/00f/?text=C-076',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy5',
            id          : 'C-077',
            rare        : 'SR',
            name        : '[キラMAX] くまみみクルーレッドトップス',
            imgUrl      : '//via.placeholder.com/100/fff/f00/?text=C-077',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-078',
            rare        : 'SR',
            name        : 'くまみみクルーレッドスカート',
            imgUrl      : '//via.placeholder.com/100/fff/f00/?text=C-078',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-102',
            rare        : 'SR',
            name        : '[再録] くまみみクルーレッドトップス',
            imgUrl      : '//via.placeholder.com/100/fff/f00/?text=C-102',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy5',
            id          : 'C-079',
            rare        : 'R',
            name        : 'マジックレインつゆつゆトップス',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-079',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-080',
            rare        : 'R',
            name        : 'マジックレインつゆつゆパンツ',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-080',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-081',
            rare        : 'R',
            name        : 'マジックレインつゆつゆシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-081',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-082',
            rare        : 'R',
            name        : 'マジックレインつゆつゆヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/ff8ad8/?text=C-082',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy5',
            id          : 'C-083',
            rare        : 'R',
            name        : 'レトロストライプオレンジトップス',
            imgUrl      : '//via.placeholder.com/100/fff/ff9300/?text=C-083',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-084',
            rare        : 'R',
            name        : 'レトロストライプオレンジスカート',
            imgUrl      : '//via.placeholder.com/100/fff/ff9300/?text=C-084',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-085',
            rare        : 'R',
            name        : 'レトロストライプオレンジシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/ff9300/?text=C-085',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy5',
            id          : 'C-086',
            rare        : 'R',
            name        : 'レトロストライプオレンジヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/ff9300/?text=C-086',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.6
          // ================================================================================

          item({
            collection  : 'Gummy6',
            id          : 'C-088',
            rare        : 'SR',
            name        : 'わんわんフットボールブルートップス',
            imgUrl      : '/images/items/C-088.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-089',
            rare        : 'SR',
            name        : 'わんわんフットボールブルーパンツ',
            imgUrl      : '/images/items/C-089.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-090',
            rare        : 'SR',
            name        : 'わんわんフットボールシューズ',
            imgUrl      : '/images/items/C-090.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-091',
            rare        : 'SR',
            name        : 'わんわんフットボールヘアアクセ',
            imgUrl      : '/images/items/C-091.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy6',
            id          : 'C-092',
            rare        : 'SR',
            name        : '[キラMAX] わんわんフットボールレッドトップス',
            imgUrl      : '/images/items/C-092.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-093',
            rare        : 'SR',
            name        : 'わんわんフットボールレッドパンツ',
            imgUrl      : '/images/items/C-093.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-117',
            rare        : 'SR',
            name        : '[再録] わんわんフットボールレッドトップス',
            imgUrl      : '/images/items/C-092.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy6',
            id          : 'C-094',
            rare        : 'R',
            name        : 'グレイスレースパープルトップス',
            imgUrl      : '/images/items/C-094.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-095',
            rare        : 'R',
            name        : 'グレイスレースパープルスカート',
            imgUrl      : '/images/items/C-095.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-096',
            rare        : 'R',
            name        : 'グレイスレースパープルシューズ',
            imgUrl      : '/images/items/C-096.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-097',
            rare        : 'R',
            name        : 'グレイスレースパープルヘアアクセ',
            imgUrl      : '/images/items/C-097.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy6',
            id          : 'C-098',
            rare        : 'R',
            name        : 'さくらひめたんぽぽトップス',
            imgUrl      : '/images/items/C-098.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-099',
            rare        : 'R',
            name        : 'さくらひめたんぽぽスカート',
            imgUrl      : '/images/items/C-099.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-100',
            rare        : 'R',
            name        : 'さくらひめたんぽぽシューズ',
            imgUrl      : '/images/items/C-100.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy6',
            id          : 'C-101',
            rare        : 'R',
            name        : 'さくらひめたんぽぽヘアアクセ',
            imgUrl      : '/images/items/C-101.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.7
          // ================================================================================

          item({
            collection  : 'Gummy7',
            id          : 'C-103',
            rare        : 'SR',
            name        : 'にゃんにゃんポリスブルートップス',
            imgUrl      : '/images/items/C-103.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-104',
            rare        : 'SR',
            name        : 'にゃんにゃんポリスブルースカート',
            imgUrl      : '/images/items/C-104.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-105',
            rare        : 'SR',
            name        : 'にゃんにゃんポリスシューズ',
            imgUrl      : '/images/items/C-105.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-106',
            rare        : 'SR',
            name        : 'にゃんにゃんポリスヘアアクセ',
            imgUrl      : '/images/items/C-106.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy7',
            id          : 'C-107',
            rare        : 'SR',
            name        : '[キラMAX] にゃんにゃんポリスレッドトップス',
            imgUrl      : '//via.placeholder.com/100/fff/f00/?text=C-107',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-108',
            rare        : 'SR',
            name        : 'にゃんにゃんポリスレッドスカート',
            imgUrl      : '//via.placeholder.com/100/fff/f00/?text=C-108',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-132',
            rare        : 'SR',
            name        : '[再録] にゃんにゃんポリスレッドトップス',
            imgUrl      : '//via.placeholder.com/100/fff/f00/?text=C-132',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'Gummy7',
            id          : 'C-109',
            rare        : 'R',
            name        : 'パープルフルールトップス',
            imgUrl      : '/images/items/C-109.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-110',
            rare        : 'R',
            name        : 'パープルフルールスカート',
            imgUrl      : '/images/items/C-110.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-111',
            rare        : 'R',
            name        : 'パープルフルールシューズ',
            imgUrl      : '/images/items/C-111.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-112',
            rare        : 'R',
            name        : 'パープルフルールヘアアクセ',
            imgUrl      : '/images/items/C-112.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy7',
            id          : 'C-113',
            rare        : 'R',
            name        : 'カラフルパレードイエロートップス',
            imgUrl      : '/images/items/C-113.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,

          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-114',
            rare        : 'R',
            name        : 'カラフルパレードイエロースカート',
            imgUrl      : '/images/items/C-114.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-115',
            rare        : 'R',
            name        : 'カラフルパレードイエローシューズ',
            imgUrl      : '/images/items/C-115.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy7',
            id          : 'C-116',
            rare        : 'R',
            name        : 'カラフルパレードイエローヘアアクセ',
            imgUrl      : '/images/items/C-116.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.8
          // ================================================================================

          item({
            collection  : 'Gummy8',
            id          : 'C-118',
            rare        : 'SR',
            name        : 'がおがおフルールグリーントップス',
            imgUrl      : '/images/items/C-118.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-119',
            rare        : 'SR',
            name        : 'がおがおフルールグリーンスカート',
            imgUrl      : '/images/items/C-119.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-120',
            rare        : 'SR',
            name        : 'がおがおフルールシューズ',
            imgUrl      : '/images/items/C-120.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-121',
            rare        : 'SR',
            name        : 'がおがおフルールヘアアクセ',
            imgUrl      : '/images/items/C-121.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy8',
            id          : 'C-122',
            rare        : 'SR',
            name        : 'がおがおフルールブラックトップス',
            imgUrl      : '//via.placeholder.com/100/fff/333/?text=C-122',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-123',
            rare        : 'SR',
            name        : 'がおがおフルールブラックスカート',
            imgUrl      : '//via.placeholder.com/100/fff/333/?text=C-123',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'Gummy8',
            rare        : 'SR',
          }),
          item({
            collection  : 'Gummy8',
            // id          : 'C-XXX',
            rare        : 'SR',
            // name        : '[再録] がおがおフルールブラックトップス',
            // imgUrl      : '//via.placeholder.com/100/fff/333/?text=C-XXX',
            // kind        : 'トップス',
            // color       : '黒',
            // brand       : 'DS',
            // type        : 'CO',
            // point       : 800,
            // numOwned    : { usual: 0 },
            // numReleased : { usual: 0 },
            // isProcured  : false,
            // isRecruiting: false,
          }),


          item({
            collection  : 'Gummy8',
            id          : 'C-124',
            rare        : 'R',
            name        : 'サーキットチェッカーホワイトトップス',
            imgUrl      : '/images/items/C-124.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-125',
            rare        : 'R',
            name        : 'サーキットチェッカーホワイトパンツ',
            imgUrl      : '/images/items/C-125.png',
            kind        : '',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-126',
            rare        : 'R',
            name        : 'サーキットチェッカーホワイトシューズ',
            imgUrl      : '/images/items/C-126.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-127',
            rare        : 'R',
            name        : 'サーキットチェッカーホワイトサングラス',
            imgUrl      : '/images/items/C-127.png',
            kind        : '',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Gummy8',
            id          : 'C-128',
            rare        : 'R',
            name        : 'ブルーチェックレディートップス',
            imgUrl      : '/images/items/C-128.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-129',
            rare        : 'R',
            name        : 'ブルーチェックレディースカート',
            imgUrl      : '/images/items/C-129.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-130',
            rare        : 'R',
            name        : 'ブルーチェックレディーシューズ',
            imgUrl      : '/images/items/C-130.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Gummy8',
            id          : 'C-131',
            rare        : 'R',
            name        : 'ブルーチェックレディーヘアアクセ',
            imgUrl      : '/images/items/C-131.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] Vol.9
          // ================================================================================



        ]
      }
    },

    methods: {
      collection (collection = '', rare = '') {
        return _.where(this.items, { collection, rare })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <h2>Vol.1</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy1', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy1', 'R' )" />
      <h2>Vol.2</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy2', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy2', 'R' )" />
    </template>

    <template #col2>
      <h2>Vol.3</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy3', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy3', 'R' )" />
      <h2>Vol.4</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy4', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy4', 'R' )" />
    </template>

    <template #col3>
      <h2>Vol.5</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy5', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy5', 'R' )" />
      <h2>Vol.6</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy6', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy6', 'R' )" />
    </template>

    <template #col4>
      <h2>Vol.7</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy7', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy7', 'R' )" />
      <h2>Vol.8</h2>
      <ItemList title="SR ★★" color="#00c7da" :items="collection('Gummy8', 'SR')" />
      <ItemList title="R ★"    color="#ffa1bc" :items="collection('Gummy8', 'R' )" />
    </template>

    <template #col5>
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    bottom: 0;
  }

  // 各カラムごとの見出し
  .Page__col > h2 {
    display: block;
    margin: 0 0 0 4px;
    padding: 0;
    font-family: $font-family--fancy;
    font-size: $size-unit * 7;
    filter: saturate(1.25);
    text-shadow:  0px  4px 1px #fff,
                  1px  4px 1px #fff,
                  2px  4px 1px #fff,
                  3px  3px 1px #fff,
                  4px  2px 1px #fff,
                  4px  1px 1px #fff,
                  4px  0px 1px #fff,
                  4px -1px 1px #fff,
                  4px -2px 1px #fff,
                  3px -3px 1px #fff,
                  2px -4px 1px #fff,
                  1px -4px 1px #fff,
                  0px -4px 1px #fff,
                 -1px -4px 1px #fff,
                 -2px -4px 1px #fff,
                 -3px -3px 1px #fff,
                 -4px -2px 1px #fff,
                 -4px -1px 1px #fff,
                 -4px  0px 1px #fff,
                 -4px  1px 1px #fff,
                 -4px  2px 1px #fff,
                 -3px  3px 1px #fff,
                 -2px  4px 1px #fff,
                 -1px  4px 1px #fff,
                  0px  4px 1px #fff;
    color: red;

    &:not(:first-of-type) {
      margin-top: $size-unit * 10;
    }
  }

  // 各カラム内のレアリティ別の ItemList 同士を密集させる
  .Page ::v-deep .ItemList {
    margin-top: 0;
    margin-bottom: 0;

    &__title {
      @include iroha-hidden();
    }

    &__body {
      margin-top: $size-unit * 2;
    }
  }
</style>
